import React, { useContext, useEffect, useState } from "react";
import SettingsIndex from "./SettingsIndex";
import {
  RavenActionBar,
  RavenBadge,
  RavenButton,
  RavenInputField,
} from "@ravenpay/raven-bank-ui";
import Icons from "../../../assets/icons/icons";
import "../../../styles/dashboard/settings/settlementAccountIndex.css";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import { ThreeDots } from "react-loader-spinner";
import {
  accountLookUp,
  changeSettlementDetails,
  getAllBanks,
  getMerchantSettlementInfo,
} from "../../../redux/insight";
import Skeleton from "react-loading-skeleton";
import ImageTextFragment from "../../../fragments/ImageTextFragment";
import { reactSelectStyle } from "../../../helper";
import ActionContext from "../../../context/ActionContext";
import { removeSpace } from "../../../utils/helpers";
import CheckUrlFragment from "../../../fragments/CheckUrlCodeFragment";
import { useDarkMode } from "../../../utils/themes/useDarkMode";

interface AccountLookUpDetails {
  bank_code: string;
  account_number: string;
}
const SettlementAccountIndex = () => {
  const [editMode, seteditMode] = useState(false);
  const [editPendingMode, setEditPendingMode] = useState(false);
  const {
    loading_reciept,
    all_banks,
    settlement_details,
    loading_trx,
    loading_alert,
  } = useSelector((state: RootState) => state.insights);
  type detailsProps = {
    account_number?: string;
    bank?: { label: string; value: string };
    account_name?: string;
  };
  const [theme, toggleTheme] = useDarkMode(localStorage.getItem("theme"));
  const [details, setDetails] = useState<detailsProps>({
    account_number: "",
    bank: { label: "", value: "" },
    account_name: "",
  });
  const [pendingDetails, setPendingDetails] = useState<detailsProps>({
    account_number: "",
    bank: { label: "", value: "" },
    account_name: "",
  });
  const actionCtx = useContext(ActionContext);

  const dispatch = useDispatch();
  // const [pendingMode, setPendingMode] = useState(false);
  const handleGetSettlementInfo = async () => {
    const loginDetail = {
      duration: "",
    };
    dispatch(getMerchantSettlementInfo(loginDetail as any) as any);
  };

  const handleChangeSettlementInfo = async () => {
    const obj = {
      account_number: details?.account_number,
      bank_code: details?.bank?.value,
      account_name: details?.account_name,
      bank_name: details?.bank?.label,
    };
    const data = await dispatch(changeSettlementDetails(obj as any) as any);
    if (data?.payload?.status === "success") {
      handleSettlementDetialsFinish();
    }
  };

  // const handleChangePendingSettlementInfo = async () => {
  //   const obj = {
  //     account_number: pendingDetails.account_number,
  //     bank_code: pendingDetails?.bank?.value,
  //     account_name: pendingDetails?.account_name,
  //     bank_name: pendingDetails?.bank?.label,
  //   };
  //   const data = await dispatch(changeSettlementDetails(obj as any) as any);
  //   if (data?.payload?.status === "success") {
  //     handleSettlementDetialsFinish();
  //   }
  // };
  useEffect(() => {
    if (
      Object?.keys(actionCtx?.configDetails)?.length > 0 &&
      Object?.keys(settlement_details)?.length < 1
    ) {
      handleGetSettlementInfo();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCtx?.configDetails]);

  const fetchBanks = async () => {
    dispatch(getAllBanks({}) as any);
  };

  const lookupAccountNumber = async (lookupDetails: AccountLookUpDetails) => {
    // console.log("i have gotten here")
    const data = await dispatch(accountLookUp(lookupDetails) as any);
    // console.log(data);
    if (data?.payload?.status === "success") {
      const name = data?.payload?.data?.data;
      setDetails((prev) => {
        return { ...prev, account_name: name };
      });
    }
  };

  useEffect(() => {
    if (
      all_banks.length < 1 &&
      Object?.keys(actionCtx?.configDetails)?.length < 1
    ) {
      fetchBanks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCtx?.configDetails, editMode]);

  useEffect(() => {
    if (Object?.keys(settlement_details)?.length > 0) {
      if (Object?.keys(settlement_details?.account_request)?.length > 0) {
        setDetails((prev) => {
          return {
            ...prev,
            account_number:
              settlement_details?.account_request?.new_account_number,
            bank: {
              label: settlement_details?.account_request?.new_bank,
              value:
                settlement_details?.account_request?.new_bank_code ||
                getBankCode(settlement_details?.account_request?.new_bank)
                  ?.code,
            },
            account_name: settlement_details?.account_request?.new_account_name,
          };
        });
      }
    }
  }, [settlement_details]);

  const handleSettlementDetialsFinish = () => {
    seteditMode(false);
    handleGetSettlementInfo();
    setDetails((prev) => {
      return {
        ...prev,
        account_number: "",
        bank: { label: "", value: "" },
        account_name: "",
      };
    });
  };

  const formatBankList = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return { ...chi, label: chi?.name, value: chi?.code };
      });
      return newList;
    }
  };
  const [informExist, setInformExist] = useState<boolean>(false);

  useEffect(() => {
    if (disableCond() && editMode) {
      const lookupDetails = {
        bank_code: details?.bank?.value,
        account_number: details?.account_number,
      };
      lookupAccountNumber(lookupDetails as any);
      setInformExist(false);
    }

    if (
      Object?.keys(settlement_details)?.length > 0 &&
      Object?.keys(settlement_details?.account_request)?.length > 0
    ) {
      if (
        Object?.keys(settlement_details)?.length > 0 &&
        details?.bank?.value &&
        details?.account_number &&
        removeSpace(String(details?.account_number))?.length > 9 &&
        (details?.bank?.value ===
          settlement_details?.settlement_accounts?.bank_code ||
          details?.account_number ===
            settlement_details?.settlement_accounts?.account_number) &&
        Object?.keys(settlement_details?.account_request)?.length < 1
      ) {
        setInformExist(true);
      }
      // if (
      //   Object?.keys(settlement_details)?.length > 0 &&
      //   details?.bank?.value &&
      //   details?.account_number &&
      //   removeSpace(String(details?.account_number))?.length > 9 &&
      //   (details?.bank?.value ===
      //     getBankCode(settlement_details?.account_request?.new_bank)?.code ||
      //     details?.account_number ===
      //       settlement_details?.account_reques?.new_account_number) &&
      //   Object?.keys(settlement_details?.account_request)?.length > 0
      // ) {
      //   setInformExist(true);
      // }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details?.account_number, details?.bank]);

  const disableCond = () => {
    let actualVal;
    if (
      Object?.keys(settlement_details)?.length > 0 &&
      Object?.keys(settlement_details?.account_request)?.length > 0
    ) {
      const val =
        details?.bank?.value &&
        details?.account_number &&
        removeSpace(String(details?.account_number))?.length > 9 &&
        (details?.bank?.value !==
          getBankCode(settlement_details?.account_request?.new_bank)?.code ||
          details?.account_number !==
            settlement_details?.account_request?.new_account_number);
      actualVal = val;
    } else {
      const val =
        details?.bank?.value &&
        details?.account_number &&
        removeSpace(String(details?.account_number))?.length > 9 &&
        (details?.bank?.value !==
          settlement_details?.settlement_accounts?.bank_code ||
          details?.account_number !==
            settlement_details?.settlement_accounts?.account_number);
      actualVal = val;
    }

    return actualVal;
  };

  const getBankCode = (label: string) => {
    if (label) {
      const obj = all_banks?.find((chi?: any) => chi?.name === label);
      return obj;
    }
  };

  return (
    <SettingsIndex>
      <div
        onClick={() => {
          console.log(
            getBankCode(settlement_details?.account_request?.new_bank)?.code
          );
        }}
        className="settlement-account-settings-right-side-wrap-cont-inner border-theme"
      >
        <div className="settings-right-side-wrap-cont-heading-wrap">
          <div className="settings-right-side-wrap-cont-heading">
            <div className="settings-right-side-wrap-cont-heading-with-action">
              <p className="settings-right-side-wrap-cont-heading-header">
                Settlement Account
              </p>
            </div>

            {/* {!pendingApproval && ( */}
            {Object?.keys(settlement_details)?.length > 0 &&
            Object?.keys(settlement_details?.account_request)?.length < 1 ? (
              <div
                className="settings-right-side-wrap-cont-icon-text"
                onClick={() => seteditMode(!editMode)}
              >
                {!editMode && (
                  <div className="settings-right-side-wrap-cont-heading-icon">
                    <figure>
                      {Icons.plainEditPen(
                        theme === "light" ? "#020202" : "#ffffff"
                      )}
                    </figure>
                  </div>
                )}

                <p className="settings-right-side-wrap-cont-heading-text">
                  {editMode ? "CLOSE EDIT" : "EDIT"}
                </p>
              </div>
            ) : (
              ""
            )}
            {/* )} */}
          </div>
        </div>
        <div className="settlement-account-info-details-outer-drive-outer">
          {editMode && (
            <p className="old-account-tag">Current Account Details</p>
          )}

          <div className="settlement-account-info-details-outer-drive">
            <div className="settlement-account-info-details-outer-drive border-theme">
              <div className="settlement-account-info-details-in-drive">
                <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                  Account No.:
                </p>
                {loading_reciept ? (
                  <>
                    <Skeleton width={650} height={20} />
                  </>
                ) : (
                  <p className="value">
                    {settlement_details?.settlement_accounts?.account_number}
                  </p>
                )}
              </div>
              <div className="settlement-account-info-details-in-drive-middle border-theme-top border-theme-bottom">
                <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                  Bank:
                </p>
                {loading_reciept ? (
                  <>
                    <Skeleton width={650} height={20} />
                  </>
                ) : (
                  <div className="bank-name-and-bank-icon">
                    <div className="image-box-holder-wrap border-theme ">
                      {/* <figure className="img-box">{bankIcon}</figure> */}
                      <CheckUrlFragment
                        url={`https://businessapi.getraventest.com/static/media/banks/${settlement_details?.settlement_accounts?.bank_code}.png `}
                      ></CheckUrlFragment>
                    </div>

                    <p className="settlement-account-info-details-in-drive-text value">
                      {settlement_details?.settlement_accounts?.bank}
                    </p>
                  </div>
                )}
              </div>

              <div className="settlement-account-info-details-in-drive">
                <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                  Account Name:
                </p>

                <p className="settlement-account-info-details-in-drive-text-account-name value">
                  {loading_reciept ? (
                    <>
                      <Skeleton width={650} height={20} />
                    </>
                  ) : (
                    settlement_details?.settlement_accounts?.account_name
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
        <>
          {Object?.keys(settlement_details)?.length > 0 &&
          Object?.keys(settlement_details?.account_request)?.length > 1 ? (
            <>
              <div className="settings-right-side-wrap-cont-heading-wrap">
                <div className="action-bar-box">
                  <RavenActionBar
                    msg={
                      editMode
                        ? `New settlement account request pending, kindly click on  " CLOSE EDIT " to retain request details. `
                        : `New settlement account request pending, kindly click on  " EDIT REQUEST " to change request details. `
                    }
                    type="warning"
                    visible
                    actionText={editMode ? "CLOSE EDIT" : "EDIT REQUEST"}
                    onAction={() => {
                      seteditMode(!editMode);
                    }}
                  />
                </div>
                <div className="settings-right-side-wrap-cont-heading">
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      gap: "2rem",
                      justifyContent: "flex-end",
                      marginBottom: "-6rem",
                    }}
                    className=""
                  >
                    {editMode && (
                      <>
                        {" "}
                        <RavenButton
                          label="Save Changes"
                          color="deep-green-light"
                          disabled={!disableCond() || !details?.account_name}
                          onClick={() => {
                            handleChangeSettlementInfo();
                          }}
                          loading={loading_alert}
                        />
                      </>
                    )}
                  </div>
                </div>
                {!editMode && (
                  <div className="settlement-account-info-details-outer-drive-outer">
                    <p className="old-account-tag">Pending Approval Account</p>

                    <div className="settlement-account-info-details-outer-drive">
                      <div className="settlement-account-info-details-outer-drive border-theme">
                        <div className="settlement-account-info-details-in-drive">
                          <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                            Account No.:
                          </p>
                          {loading_reciept ? (
                            <>
                              <Skeleton width={650} height={20} />
                            </>
                          ) : (
                            settlement_details?.account_request
                              ?.new_account_number
                          )}
                        </div>
                        <div className="settlement-account-info-details-in-drive-middle border-theme-top border-theme-bottom">
                          <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                            Bank:
                          </p>
                          {loading_reciept ? (
                            <>
                              <Skeleton width={650} height={20} />
                            </>
                          ) : (
                            <div className="bank-name-and-bank-icon">
                              <div className="image-box-holder-wrap border-theme">
                                <CheckUrlFragment
                                  url={`https://businessapi.getraventest.com/static/media/banks/${
                                    getBankCode(
                                      settlement_details?.account_request
                                        ?.new_bank
                                    )?.code
                                  }.png `}
                                >
                                  {/* <figure className="img-box">svg</figure> */}
                                </CheckUrlFragment>
                              </div>

                              <p className="settlement-account-info-details-in-drive-text">
                                {settlement_details?.account_request?.new_bank}
                              </p>
                            </div>
                          )}
                        </div>

                        <div className="settlement-account-info-details-in-drive">
                          <p className="settlement-account-info-details-in-drive-text-left grey-white-color">
                            Account Name:
                          </p>

                          <p className="settlement-account-info-details-in-drive-text-account-name">
                            {loading_reciept ? (
                              <>
                                <Skeleton width={650} height={20} />
                              </>
                            ) : (
                              settlement_details?.account_request
                                ?.new_account_name
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>{" "}
            </>
          ) : (
            ""
          )}
        </>
        {/* input of account section start --------------------------------- */}
        {editMode && (
          <>
            <div className="bottom-siv-general-wrap-holder">
              <div className="bottom-siv-general-wrap-holder-new-account-and-edit">
                {!editMode && <p className="new-account-box">New Account</p>}
                {Object?.keys(settlement_details?.account_request)?.length <
                  1 && (
                  <div className="settings-right-side-wrap-cont-icon-text">
                    {/* <div className="settings-right-side-wrap-cont-heading-icon">
                  <figure>{Icons.plainEditPen}</figure>
                </div> */}
                    <RavenButton
                      label="Save Changes"
                      color="deep-green-light"
                      disabled={!disableCond() || !details?.account_name}
                      onClick={() => {
                        handleChangeSettlementInfo();
                      }}
                      loading={loading_alert}
                    />
                  </div>
                )}
              </div>
              <RavenActionBar
                visible={informExist}
                msg={`Kindly note that the selected bank details is the current settlement details`}
                actionText="Change Details"
                type="info"
                onAction={() => {
                  setDetails((prev: any) => {
                    return {
                      ...prev,
                      account_number: "",
                      account_name: "",
                      bank: "",
                    };
                  });
                  setInformExist(false);
                }}
              />
              <div className="settings-right-side-wrap-cont-input-fields">
                <RavenInputField
                  type="select"
                  label="Select bank"
                  color="deep-green-light"
                  selectOption={formatBankList(all_banks)}
                  disabled={!editMode}
                  placeholder={`Select bank`}
                  onChange={(e: any) => {
                    setDetails((prev) => {
                      return {
                        ...prev,
                        bank: e,
                        account_number: "",
                        account_name: "",
                      };
                    });
                    informExist && setInformExist(false);
                  }}
                  labelSpanText={
                    loading_trx ? (
                      <>
                        <div
                          style={{
                            padding: "0rem",
                            display: "flex",
                            justifyContent: "flex-end",
                            transform: "translateX(1.5rem)",
                          }}
                          className="load-wrap"
                        >
                          <ThreeDots
                            height="10"
                            width="80"
                            radius="9"
                            // color="#020202"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            visible={true}
                          />
                        </div>
                      </>
                    ) : (
                      ("" as any)
                    )
                  }
                  menuPlacement={`top`}
                  value={details?.bank}
                  name="bank_name"
                  selectStyles={reactSelectStyle}
                />

                <RavenInputField
                  color="deep-green-light"
                  type="account-number"
                  label="Account Number"
                  placeholder={`Enter account number`}
                  className="settings-account-number-input-botton-that-has-a-diffrent-color"
                  labelSpanText={disableCond() ? "Verify" : ""}
                  onActionClick={() => {
                    const lookupDetails = {
                      bank_code: details?.bank?.value,
                      account_number: details?.account_number,
                    };
                    lookupAccountNumber(lookupDetails as any);
                  }}
                  maxLength={10}
                  value={details?.account_number}
                  onChange={(e: any) => {
                    setDetails((prev) => ({
                      ...prev,
                      account_number: e.target.value,
                      account_name: "",
                    }));
                    informExist && setInformExist(false);
                  }}
                />
              </div>
              {details?.account_name && (
                <div className="bottom-name-holder ">
                  <RavenBadge type={`info`} text={details?.account_name} />
                </div>
              )}
            </div>
          </>
        )}
        {/* )} */}
      </div>
    </SettingsIndex>
  );
};

export default SettlementAccountIndex;
